'use client';

import {
  type SignInType,
  SignInForm as CoreSignInForm,
} from '@bells/ui/screens/signin-form';
import { useLanguage } from '@bells/core/i18n';
import {
  authAttendantDescription,
  authAttendantTitle,
  authBecomeAttendant,
  authBecomeAttendantQuestion,
  authBecomeCustomer,
  authBecomeCustomerQuestion,
  authDescription,
  authTitle,
} from '@bells/i18n/messages';
import { ProfileType } from '@bells/schema/models/signup';
import Link from 'next/link';
import { baseLocale } from '@bells/i18n/runtime';

export default function RegisterForm({
  type = 'email',
  profileType = ProfileType.Customer,
  callbackUrl,
  error,
}: {
  type?: SignInType;
  profileType?: ProfileType;
  callbackUrl?: string;
  error?: string;
}) {
  const { language } = useLanguage();

  return (
    <>
      <div className='mb-8 grid gap-2 text-center'>
        <h1 className='text-3xl font-bold'>
          {profileType == ProfileType.Customer
            ? authTitle()
            : authAttendantTitle()}
        </h1>
        <p className='text-balance text-muted-foreground'>
          {profileType == ProfileType.Customer
            ? authDescription()
            : authAttendantDescription()}
        </p>
      </div>

      <CoreSignInForm
        error={error}
        verifyUrl={
          baseLocale != language ? `/${language}/auth/verify` : `/auth/verify`
        }
        type={type}
        callbackUrl={callbackUrl}
        profileType={profileType}
      ></CoreSignInForm>
      <div className='grid gap-4'>
        {profileType == ProfileType.Customer && (
          <div className='mt-4 text-center text-sm'>
            {authBecomeCustomerQuestion()} {` `}
            <Link
              prefetch={false}
              href={
                baseLocale != language
                  ? `/${language}/auth/signin/attendant`
                  : `/auth/signin/attendant`
              }
              className='underline'
            >
              {authBecomeAttendant()}
            </Link>
          </div>
        )}

        {profileType == ProfileType.Attendant && (
          <div className='mt-4 text-center text-sm'>
            {authBecomeAttendantQuestion()} {` `}
            <Link
              prefetch={false}
              href={
                baseLocale != language
                  ? `/${language}/auth/signin/customer`
                  : `/auth/signin/customer`
              }
              className='underline'
            >
              {authBecomeCustomer()}
            </Link>
          </div>
        )}
      </div>
    </>
  );
}
